var $ = require('jquery'),
sliderIsSliding = false; //Avoid multiple clicks during slider transitions

import * as utils from './utils.js';
import * as Ajax from './utils/ajax.js';
import * as BI from './tracking/bi.js';

import { makeCommentCreateEvent } from './utils/comment.js';

// Data models tracking (BI & Zendesk)
import { ProductLikeBIModel } from "./BI/models";

$(function() {

    if (utils.config.forceRefreshUser && utils.canCallApp("refreshUser")) {
        Trendier.refreshUser();
    }

    //Mask and unmask input passwords
    $(document).on('click','.js-togglePasswordVisibility', function() {
        var input = $(this).parent().siblings('input');
        input.attr('type') === 'password' ? input.attr('type', 'text') : input.attr('type', 'password');
        $(this).toggleClass('icon-eye-open icon-eye-banned');
    });

    //Show dropdown with slide effect
    $(document).on('show.bs.dropdown', '.dropdown', function () {
        $(this).find('.dropdown-menu').stop(true, true).slideDown('fast');
    });

    //Hide dropdown with slide effect
    $(document).on('hide.bs.dropdown', '.dropdown', function () {
        $(this).find('.dropdown-menu').stop(true, true).slideUp('fast');
    });

    //Avoid closing dropdown on click
    $(document).on('click', '.dropdown-menu', function(e) {
        if ($(this).hasClass('show')) {
            e.stopPropagation();
        }
    });

    //Dropdown text filter
    $(document).on('keyup', '.dropdown .js-dropdownSearch', function() {
        var input, list, elements, i, text;
        input = $(this).val().toUpperCase();
        elements = $(this).parents('.dropdown').find('.dropdown-menu-content').find('.dropdown-item');
        if (input) {
            $(this).next('.input-group-append').find('.icon-search').removeClass('icon-search').addClass('icon-close');
        } else {
            $(this).next('.input-group-append').find('.icon-close').removeClass('icon-close').addClass('icon-search');
        }
        for (i = 0; i < elements.length; i++) {
            text = $(elements[i]).find('label.custom-checkbox').text();
            if (text.toUpperCase().startsWith(input)) {
                $(elements[i]).show();
            } else {
                $(elements[i]).hide();
            }
        }
    });

    //Dropdown clear text filter
    $(document).on('click', '.dropdown .icon-close', function() {
        $(this).parent().prev('input.js-dropdownSearch').val('');
        $(this).removeClass('icon-close').addClass('icon-search');
        $(this).parents('.dropdown').find('.dropdown-menu-content').find('.dropdown-item').show();
    });

    //Like button
    $(document).on('click', '.js-like-it', function(e){

        if(utils.redirectAnonymous()){
            return;
        }

        const isOwner = !!e.target.dataset.isOwner;
        const heart = $(this).find('.js-heart').toggleClass('icon-heart icon-heart-filled');
        const liked = heart.hasClass('icon-heart-filled'), productId = this.dataset.pid, userId = this.dataset.puid;
        const countContainer = this.parentNode.querySelector('.js-like-count');
        let count = parseInt(countContainer.textContent || '0');
        const inProductSheet = document.getElementById('product-sheet') != null;

        Ajax[liked ? 'post' : 'del'](`/api/v5/products/${productId}/like`, undefined, true, true).then((response) => {
            if(response.result == 1) {
                const countrySellerFicha = document.getElementById('product-sheet')?.dataset.biCountrySeller || '';
                const sellerCurrencyCard = $(this).closest('[data-bi-seller-currency]')?.dataset?.biSellerCurrency || '';
                const countrySeller = countrySellerFicha || BI.currencyToCountryISO(sellerCurrencyCard);
                const productLikeBIModel = new ProductLikeBIModel(
                    utils.config.user.id,
                    parseInt(productId),
                    parseInt(userId),
                    liked ? "like" : "dislike",
                    utils.getFlow(),
                    isOwner,
                    inProductSheet ? "product" : "grid",
                    countrySeller
                );
                BI.track(productLikeBIModel);
                if (liked) {
                    dataLayer.push({
                        'event': 'like',
                        'item_id': `${this.dataset.pid}`,
                        'item_name': `${this.dataset.datalayerItemName}`,
                        'item_brand': `${this.dataset.datalayerItemBrand}`,
                        'item_category': `${this.dataset.datalayerItemCategory}`,
                        'item_variant': `${this.dataset.datalayerItemSize}`,
                        'item_variant1': `${this.dataset.datalayerItemStatus}`,
                        'price': `${this.dataset.datalayerPrice}`,
                        'quantity': `${count}`
                    });
                }
            } else if(typeof response.result === 'undefined') {

                utils.defaultAlertModal('Ha ocurrido un error');
                heart.toggleClass('icon-heart icon-heart-filled');
                count -= liked ? 1 : -1;
                countContainer.textContent = Math.max(count, 0) || '';
            }
        });
        count += liked ? 1 : -1;
        countContainer.textContent = Math.max(count, 0) || '';
        if (inProductSheet) { //En la ficha debemos mantener los 2 botones de like sincronizados
            document.querySelectorAll('.js-like-count').forEach(count => {
                count.textContent = countContainer.textContent;
            });
            document.querySelectorAll('.js-heart').forEach(icon => {
                icon.classList.toggle('icon-heart-filled', liked);
                icon.classList.toggle('icon-heart', !liked);
            });
        }
    });

    //Grid comment icon button
    $(document).on('click', '.icon-message', function() {
        $(this).parents('.card').first().find('input[name="commentText"]').focus();
    });

    //Copy to clipboard on share
    $(document).on('click', '.share-clipboard-copy', function(e) {
        $(this).find('.js-share-text').text('¡copiado!');
    });

    //Popover
    $.fn.popover.Constructor.Default.whiteList['*'].push(/^data-[\w-]+/); // allow dataset attributes since by default it blows them all
    $('[data-toggle="popover"]').popover();

    $(document).on('click', '.share-box a', function(){
        window.setTimeout(() => {
            $(this).closest('.popover').popover('hide');
            $(this).closest('.popover').popover('dispose');
        }, 2000);

    });

    //On Window resize
    $(window).resize(function() {
        //Close popovers
        $('[data-toggle="popover"]').each(function() {
            $(this).popover('hide')
        });
    });

    //Home sliders navigation
    $(document).on('click', '.slider .slider-nav', function(e) {
        e.preventDefault();
        if (!sliderIsSliding) {
            sliderIsSliding = true;
            var container = $(this).parent('.slider'),
                slider = container.find('.slider-inner'),
                current = slider.find('.slide.first'),
                prev = current.prev('.slide'),
                next = current.next('.slide'),
                offset = current.outerWidth(true),
                showNext = $(this).hasClass('nav-next');
            slider.css('margin-left', function() {
                if (showNext) {
                    current = next;
                    return (parseInt($(this).css('margin-left')) + (offset * -1)) + "px";
                } else {
                    current = prev;
                }   return (parseInt($(this).css('margin-left')) + offset) + "px";
            });
            slider.find('.slide').each(function() {
                $(this).removeClass('first');
            });
            current.addClass('first');
            prev = current.prev('.slide');
            next = current.next('.slide');
            next.length ? container.find('.nav-next').css({display: 'block'}) : container.find('.nav-next').css({display: 'none'});
            prev.length ? container.find('.nav-prev').css({display: 'block'}) : container.find('.nav-prev').css({display: 'none'});
            slider.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
                sliderIsSliding = false;
            });
        }
    });

    //
    //Filters
    $(document).on('click', '#filters-mobile-container .icon-close', function(e) {
        e.preventDefault();
        $('#filters-mobile-container').removeClass('showing');
        if ($(window).width() <= utils.mobileBreakPoint) {
            $('html, body').toggleClass('overflow-hidden');
            $('body').toggleClass('position-relative');
        }
    });
    $(document).on('click', '.show-filters-mobile', function(e) {
        e.preventDefault();
        $('#filters-mobile-container').addClass('showing');
        if ($(window).width() <= utils.mobileBreakPoint) {
            $('html, body').toggleClass('overflow-hidden');
            $('body').toggleClass('position-relative');
        }
    });
    $(document).on('click', '.js-filter-step', function(e) {
        e.preventDefault();
        var selectedOption = $(this),
            currentStep = selectedOption.closest('.filters-mobile-inner-content');
        if (currentStep.next().length) {
            var nextStep = currentStep.next().find('[data-name="' + selectedOption.data('name') + '"]');
            selectedOption.addClass('bg-grey-050');
            nextStep.removeClass('d-none').siblings().addClass('d-none');
            currentStep.animate({width: 'toggle'}, 0);
            $('.js-filters-mobile-back .icon-chevron-left').removeClass('d-none');
            $('#js-filters-mobile-title').text(selectedOption.find('.filter-name').text());
            currentStep.add(currentStep.next()).toggleClass('js-showing');
            currentStep.next().removeClass('d-none');
        }
    });
    $(document).on('click', '.js-filters-mobile-back', function() {
        overlayGoBack();
    });

    //Header Searchbar dropdown
    $(document).on('click', '#header-searchbar .dropdown-menu .dropdown-item', function() {
        var selected = $(this).data('search-for');
        $(this).addClass('font-weight-bold');
        $(this).siblings().removeClass('font-weight-bold');
        $('#header-searchbar .btn.dropdown-toggle').attr('data-search-for', selected).text($(this).text());
        if (selected == 'products') {
            $('#header-searchbar input').attr('placeholder', 'Buscar en productos...'); //TODO - Traducciones en js
        } else if (selected == 'users') {
            $('#header-searchbar input').attr('placeholder', 'Buscar en clósets...'); //TODO - Traducciones en js
        }
        $('#header-searchbar .dropdown-toggle').dropdown('hide');
        $('#header-searchbar .input-group').removeClass('input-shadow');
    });
    $(document).on('click focus', '#header-searchbar .dropdown-toggle, #header-searchbar input', function() {
        $('#header-searchbar .input-group').addClass('input-shadow');
    });
    $(document).on('focusout', '#header-searchbar input', function() {
        $('#header-searchbar .input-group').removeClass('input-shadow');
    });
    $(document).on('input', '.input-group input[type="text"]', function() {
        var val = $(this).val();
        $(this).parents('.input-group').find('.icon-close-circle-filled').toggleClass('invisible', val ? false : true);
    });
    $(document).on('click', '#header-searchbar .icon-search', function() {
        //TODO - Resultados búsqueda
    });
    $(document).on('click', '.input-group-append .icon-close-circle-filled', function() {
        const $input = $(this).parents('.input-group').find('input');
        $input.val('');
        // force trigger input event, as it won't be fired for emptying it's value (useful for: getBrandsStartingWith)
        $input[0].dispatchEvent(new Event('input', {
            'bubbles': true,
            'cancelable': true
        }));
        $(this).addClass('invisible');
    });

    //
    // Login/register tab toggle
    $(document).on('click', '.js-toggle-login-register', function(e) {
        e.preventDefault();
        $('#login-tab').hasClass('active') ? $('[href="#register-tab"]').tab('show') : $('[href="#login-tab"]').tab('show');
    });


    //
    // Close collapse elems when clicking outside
    $(document).click(function(e) {
        if (!$(e.target).is('.collapse.show, .collapse.show *')) {
            $('.collapse.js-close-on-outer-click').collapse('hide');
        }
        if (!$(e.target).is('header .notification-container.show, header .notification-container.show *')) {
            $('header .notification-container').removeClass('show');
        }
        if (!$(e.target).is('header .user-menu.show, header .user-menu.show *')) {
            $('header .user-menu').removeClass('show');
        }
    });
});

//Filter mobile navigation
function overlayGoBack()
{
    if ($('.js-showing').data('step') != '0') {
        var currentStep = $('#filters-mobile-body .js-showing'),
            prevStep = currentStep.prev(),
            prevStepTitle = prevStep.prev().length ? prevStep.prev().find('.bg-grey-050').find('.filter-name').text() : $('#js-filters-mobile-title').data('name');
        prevStep.animate({width: 'toggle'}, 0);
        currentStep.find('> *').removeClass('d-none');
        currentStep.add(prevStep).toggleClass('js-showing');
        $('#js-filters-mobile-title').text(prevStepTitle);
        if ($('#filters-mobile-body').length && !$('#filters-mobile-body .js-showing').prev().length) {
            $('.js-filters-mobile-back .icon-chevron-left').addClass('d-none');
        }
    }
}

//Comentar Parrilla
$(document).on('submit', '.add-comment-grid-form', function(e) {
    e.preventDefault();
    const $input = $(this).find('input[name="txtcomment"]');
    if ($input.val().length < 2) {
        return;
    }
    if(utils.redirectAnonymous()){
        return;
    }
    const productCommentsUrl = $(this).closest('.card').find('a.card-img').attr('href') + '#comments';
    Ajax.post($(this).attr('action'), new FormData(this)).then((response)=> {
        if(response.success) {
            let $newComment = $('#new-comment-template').html().trim();
            $newComment = $($newComment);
            $newComment.find('.js-new-comment-template-text').html(utils.boldCitations(response.commentText)).attr('href', productCommentsUrl);
            $input.val('');
            $(this).closest('.card').find('.card-body .js-card-comment').replaceWith($newComment);
            $(this).closest('.card').find('.card-body .js-total-comments').html(parseInt($(this).closest('.card').find('.card-body .js-total-comments').html()) + 1);

            document.dispatchEvent(makeCommentCreateEvent(this));
            this.dataset.productTotalComments++;
            this.dataset.timeSinceLastComment = 0;
        } else {
            utils.defaultAlertModal('Ha ocurrido un error al intentar realizar el comentario.');
        }
    });
});

$(document).on('click', 'a[href="#filter-change"]', function(e){
    e.preventDefault();
    let input = $(this).closest('form').find('input[name="' + $(this).data('filter') + '"], .' + $(this).data('filter') + ' input'); //Main input
    $(this).closest('form').find('a[data-filter="' + $(this).data('filter') + '"] .icon-tick').addClass('d-none'); // Untick all same option filters (categories, colors,... )
    if ( input.val() == $(this).data('value') ) {
        input.val('').trigger('change');
    } else {
        input.val($(this).data('value')).trigger('change');
        $(this).find('.icon-tick').removeClass('d-none');
    }
    document.dispatchEvent(new CustomEvent('filterChange'));
    window.scrollTo(0, 0);
});

$(document).on('click', 'a[href="#filter-change-multi"]', function(e){
    e.preventDefault();
    var input = $(this).closest('form').find('input[name="' + $(this).data('filter') + '"][value="' + $(this).data('value') + '"]');
    if (input.length){
        input.remove();
        $(this).find('.icon-tick').addClass('d-none');
    } else {
        $(this).closest('form').append(
            $('<input type="hidden">').attr('name', $(this).data('filter')).val($(this).data('value'))
        );
        $(this).find('.icon-tick').removeClass('d-none');
    }
});